var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2222",
    "data-name": "Rectangle 2222",
    width: 89,
    height: 89,
    transform: "translate(-0.263 -0.263)",
    fill: "#d9000d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10514",
    "data-name": "Group 10514",
    transform: "translate(2.043 1.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10359",
    "data-name": "Group 10359",
    transform: "translate(-1.78 -1.516)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27733",
    "data-name": "Path 27733",
    d: "M42.246,0A42.246,42.246,0,1,0,84.491,42.246,42.255,42.255,0,0,0,42.246,0m0,77.45a35.2,35.2,0,1,1,35.2-35.2,35.212,35.212,0,0,1-35.2,35.2",
    transform: "translate(2.291 1.955)",
    fill: "#d9000d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27734",
    "data-name": "Path 27734",
    d: "M31.189,35.927l-15.9-9.533V7.27a3.52,3.52,0,0,0-7.041,0V28.393a3.826,3.826,0,0,0,1.7,3.028l17.6,10.561a3.531,3.531,0,1,0,3.633-6.055",
    transform: "translate(32.766 15.807)",
    fill: "#d9000d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.8978bd3dcd9aa2273f70628f85c76144.svg";
export { ForwardRef as ReactComponent };